import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CookieService } from '@coin-depo-core/storage';
import { BaseApiService } from './base.service';

import { ServerNotRespondingService } from '@coin-depo-core/server-not-responding.service';
import { StorageService } from '@coin-depo-core/storage';

import type {
  BaseApiRequest,
  ExtendedApiResponse,
  DepositPlansRequest,
  DepositPlansResponse,
  DepositPlansAlt,
} from '@coin-depo-types';


@Injectable({
  providedIn: 'root',
})
export class CommonApiService extends BaseApiService {
  override serviceName = 'CommonApiService';

  constructor(
    protected override http: HttpClient,
    protected override cookies: CookieService,
    protected override router: Router,
    protected override storage: StorageService,
    protected override serverNotRespondingService: ServerNotRespondingService
  ) {
    super();
  }

  getDepositPlans(
    query: DepositPlansRequest
  ): Observable<ExtendedApiResponse<DepositPlansResponse>> {
    return this.processRequest<
      DepositPlansRequest,
      ExtendedApiResponse<DepositPlansResponse>
    >('depositDropdown', query);
  }

  getDepositPlansAlt(
    query: BaseApiRequest
  ): Observable<ExtendedApiResponse<DepositPlansAlt>> {
    return this.processRequest<
      BaseApiRequest,
      ExtendedApiResponse<DepositPlansAlt>
    >('depositPlans', query);
  }

  getDepositPlansNew(
    query: DepositPlansRequest
  ): Observable<ExtendedApiResponse<DepositPlansResponse>> {
    return this.processRequest<
      DepositPlansRequest,
      ExtendedApiResponse<DepositPlansResponse>
    >('newDepositDropdown', query);
  }
}
